import axios from 'axios';
export default {
	getAnnouncements(params) {
		return axios.post('/announcement/api/query', params);
	}
};
